import { GlobalAxios } from "../axios/axios-config";
import { IRestartSyncTransactionResult } from "../models/sync-transaction";

const SYNC_TRANSACTION_RESTART_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/SyncTransaction/Restart";

export const restartSyncTransactions = ({
  identifiers,
}: {
  identifiers: number[];
}) => {
  return GlobalAxios.put<IRestartSyncTransactionResult[]>(
    SYNC_TRANSACTION_RESTART_ROUTE,
    { identifiers },
  );
};
